import PageHeader from "./PageHeader"

const SwapPageHeader = () => (
  <PageHeader
    title="Swap"
    subtitle="Centralized exchange speed, onchain."
    intro={
      <>
        <p>
          NEAR Intents is the most exciting trading technology to have emerged
          in recent years. Here, you can swap anything for almost anything else.
          BTC to ETH? No problem. ETH to ZEC? No problem. ZEC to SOL? No
          problem.
        </p>
        <p>
          Fast and cheap! Swapping between assets in your account happens within
          a couple of seconds, as competing "Solvers" compete to give you the
          best price, every time!
        </p>
      </>
    }
  />
)

export default SwapPageHeader
